/* Recent-purchase notes: "Someone in Rye Brook, NY just bought the Moira 2 · 21 minutes ago".
   Website Social Proof, 19 Oct 2026. Replaces the ProveSource script (48 KB, up to 56 ms of phone CPU on every page).
   Data comes from snippets/si-purchase-toast.liquid (the recent_purchase metaobject rows Shopify Flow writes).
   Rules: nothing during the page load; the first note 8 to 12 s after the shopper's first scroll or tap; one at a time,
   6 s each, 25 s apart; at most "Notes per visit" per browser session (sessionStorage); never the same shoe twice in a
   session; dismissible; hover or touch holds it; aria-live polite; reduced motion handled in the CSS.
   Demo: add #si-toast-demo to the page address to see three built-in sample notes (no store data). */
(function () {
  'use strict';
  var dataEl = document.getElementById('si-purchase-toast-data');
  var host = document.getElementById('si-purchase-toast');
  if (!dataEl || !host) return;

  var demo = /si-toast-demo/.test(window.location.hash);
  var cfg = {};
  try { cfg = JSON.parse(host.getAttribute('data-config') || '{}'); } catch (e) { cfg = {}; }
  var MAX = Math.max(1, parseInt(cfg.max, 10) || 3);
  var MAX_AGE = Math.max(1, parseInt(cfg.days, 10) || 7) * 86400000;
  var SHOW_MS = 6000, FIRST_MIN = 8000, FIRST_SPAN = 4000, GAP_MS = 25000, HOLD_AFTER_HOVER = 2000;
  var now = Date.now();

  var DEMO = [
    { t: 'Moira 2', h: 'moira-6', v: '', i: 'https://cdn.shopify.com/s/files/1/1143/4886/files/2_a7daea3b-8496-4fee-bb9b-583b749a25cc.png?v=1753195196', c: 'Rye Brook', p: 'NY', k: 'US', a: Math.floor(now / 1000) - 21 * 60 },
    { t: 'Laurie Slingback Pump', h: 'laurie-slingback-pump', v: '', i: 'https://cdn.shopify.com/s/files/1/1143/4886/files/1_3e1c162a-caf7-4edc-a04f-f2d0660654b9.png?v=1790183198', c: 'New York', p: 'NY', k: 'US', a: Math.floor(now / 1000) - 2 * 3600 },
    { t: 'Easter FL Sneaker', h: 'easter-fl', v: 'Back 70', i: 'https://cdn.shopify.com/s/files/1/1143/4886/files/1_1280d974-f3e9-4349-b698-bee21baa33c2.png?v=1756235066', c: 'west chester', p: 'PA', k: 'US', a: Math.floor(now / 1000) - 26 * 3600 }
  ];

  var entries = [];
  try { entries = demo ? DEMO : JSON.parse(dataEl.textContent || '[]'); } catch (e) { entries = []; }
  if (!Array.isArray(entries)) entries = [];
  entries = entries.filter(function (e) {
    if (!e || !e.t || !e.h) return false;
    e.a = parseInt(e.a, 10);
    return !!e.a && (now - e.a * 1000) >= -300000 && (now - e.a * 1000) < MAX_AGE;
  }).sort(function (x, y) { return y.a - x.a; });
  if (!entries.length) return;

  var store = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* private mode: show once per page */ } }
  };
  var shown = parseInt(store.get('si-ptoast-n'), 10) || 0;
  if (shown >= MAX && !demo) return;
  var seen = (store.get('si-ptoast-seen') || '').split(',').filter(Boolean);
  var queue = entries.filter(function (e) { return seen.indexOf(e.h) === -1; });
  if (!queue.length) queue = entries.slice();

  function titleCase(s) {
    s = String(s || '').trim();
    if (!s) return s;
    if (s === s.toLowerCase() || s === s.toUpperCase()) {
      return s.toLowerCase().replace(/(^|[\s\-'])([a-z])/g, function (m, pre, ch) { return pre + ch.toUpperCase(); });
    }
    return s;
  }
  function ago(sec) {
    var d = Math.max(0, Math.round(Date.now() / 1000 - sec));
    if (d < 90) return 'just now';
    if (d < 3600) { var m = Math.round(d / 60); return m + (m === 1 ? ' minute ago' : ' minutes ago'); }
    if (d < 86400) { var h = Math.round(d / 3600); return h + (h === 1 ? ' hour ago' : ' hours ago'); }
    var days = Math.round(d / 86400);
    return days === 1 ? 'yesterday' : days + ' days ago';
  }
  function thumb(u) {
    if (!u || typeof u !== 'string') return '';
    if (/[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function blocked() {
    return document.visibilityState !== 'visible' ||
      !!document.querySelector('cart-drawer details[open], header-drawer details[open], .mobile-facets__wrapper details[open], modal-dialog[open]');
  }

  var timer = null, current = null, hideTimer = null;

  function build(e) {
    var card = el('div', 'si-ptoast');
    var link = el('a', 'si-ptoast__link');
    link.href = '/products/' + encodeURIComponent(e.h);
    if (e.i) {
      var img = document.createElement('img');
      img.className = 'si-ptoast__img';
      img.src = thumb(e.i);
      img.width = 56; img.height = 56;
      img.loading = 'lazy';
      img.alt = e.t;
      img.onerror = function () { img.remove(); };
      link.appendChild(img);
    }
    var body = el('div', 'si-ptoast__body');
    var where = e.c ? titleCase(e.c) + (e.p ? ', ' + e.p : '') : '';
    body.appendChild(el('p', 'si-ptoast__who', where ? 'Someone in ' + where + ' just bought' : 'Someone just bought'));
    var name = e.t;
    if (e.v && name.toLowerCase().indexOf(String(e.v).toLowerCase()) === -1) name = e.v + ' ' + name;
    body.appendChild(el('p', 'si-ptoast__product', 'the ' + name));
    body.appendChild(el('p', 'si-ptoast__time', ago(e.a)));
    link.appendChild(body);
    card.appendChild(link);
    var close = el('button', 'si-ptoast__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'Dismiss');
    close.addEventListener('click', function (ev) { ev.preventDefault(); hide(true); });
    card.appendChild(close);
    card.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    card.addEventListener('mouseleave', function () { hideTimer = setTimeout(hide, HOLD_AFTER_HOVER); });
    card.addEventListener('touchstart', function () { clearTimeout(hideTimer); hideTimer = setTimeout(hide, SHOW_MS); }, { passive: true });
    return card;
  }

  function show() {
    var e = queue.shift();
    if (!e) return;
    current = build(e);
    host.appendChild(current);
    void current.offsetWidth; // flush so the transition runs
    window.requestAnimationFrame(function () { if (current) current.classList.add('is-in'); });
    shown += 1;
    seen.push(e.h);
    store.set('si-ptoast-n', String(shown));
    store.set('si-ptoast-seen', seen.slice(-20).join(','));
    hideTimer = setTimeout(hide, SHOW_MS);
  }

  function hide(dismissed) {
    clearTimeout(hideTimer);
    var node = current;
    current = null;
    if (!node) return;
    node.classList.remove('is-in');
    var gone = false;
    var done = function () { if (gone) return; gone = true; if (node.parentNode) node.parentNode.removeChild(node); };
    node.addEventListener('transitionend', done);
    setTimeout(done, 400);
    if (dismissed) return; // a dismissed note ends the notes for this visit
    if (shown < MAX && queue.length) schedule(GAP_MS);
  }

  function tick() {
    if (blocked()) { schedule(5000); return; }
    show();
  }
  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(tick, ms);
  }

  var armed = false;
  function arm() {
    if (armed) return;
    armed = true;
    ARM_EVENTS.forEach(function (ev) { window.removeEventListener(ev, arm, { passive: true }); });
    schedule(FIRST_MIN + Math.random() * FIRST_SPAN);
  }
  // 'wheel' as well as 'scroll': a mouse wheel over the desktop filter sidebar scrolls the sidebar, not the page
  var ARM_EVENTS = ['scroll', 'wheel', 'touchstart', 'pointerdown', 'keydown'];
  ARM_EVENTS.forEach(function (ev) { window.addEventListener(ev, arm, { passive: true }); });
})();
